export default "__VITE_ASSET__BAJKXjHk__"